export const ORDER = [
  { value: 'internal-score', label: 'default', direction: 'desc' },
  { value: 'amount', label: 'price-asc', direction: 'asc', arrowUp: true },
  { value: 'recent_online', label: 'recent-online', direction: 'desc', arrowDown: true },
  { value: 'reviews', label: 'review', direction: 'desc', arrowDown: true },
  { value: 'registered_date', label: 'active-since', direction: 'asc', arrowUp: true },
  // { value: 'amount', label: 'price-desc', direction: 'desc', arrowDown: true },
  // { value: 'last_login', label: 'last-login-asc', direction: 'asc', arrowUp: true },
  { value: 'last_login', label: 'last-login-desc', direction: 'desc', arrowDown: true },
];